import script from "./LinkedInWarningModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkedInWarningModal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkedInWarningModal.vue?vue&type=style&index=0&id=17d83a0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d83a0a"]])

export default __exports__